import { forwardRef } from 'react';
import { ReactKit } from '@team/react';
import { Caption } from '../../../../typography/caption';
import { ButtonOptionProps } from '../../types';
import { Tappable } from '../../../../services/tappable';
import css from './style.module.css';

export const Button = forwardRef<HTMLButtonElement, ButtonOptionProps>(
  function Component(
    { children, indicator, 'aria-selected': ariaSelected, ...props },
    forwardedRef
  ) {
    const hasIndicator = ReactKit.hasNode(indicator);

    return (
      <Tappable
        {...props}
        Component="button"
        hoverMode="opacity"
        activeMode="none"
        baseClassName={css.root}
        ref={forwardedRef}
        aria-selected={ariaSelected}
      >
        <div className={css.inner}>
          {hasIndicator && <div className={css.corner} />}

          <Caption
            className={css.label}
            level={1}
            weight={ariaSelected ? 2 : 3}
          >
            {children}
          </Caption>

          {hasIndicator && <div className={css.corner}>{indicator}</div>}
        </div>
      </Tappable>
    );
  }
);
